import { FEATURES, PRODUCT_FAMILY, PRODUCTS } from '@/base/constants/authorization'

export const accessAdIntelligenceRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.AD_INTEL } },
    { name: { $eq: PRODUCTS.AD_INTEL_ENTERPRISE } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_AD_INTELLIGENCE },
        },
      },
    },
  ],
}
export const createAccessRule = accessAdIntelligenceRule
export const manageAccessRule = createAccessRule
export const creativeAnalysisAccessRule = createAccessRule
export const advertiserAnalysisAccessRule = createAccessRule
export const adPublishersAnalysisAccessRule = createAccessRule
export const developerAnalysisAccessRule = createAccessRule
export const mediaAnalysisAccessRule = createAccessRule
export const publisherAnalysisAccessRule = createAccessRule
export const listOfAdvertisersAnalysisAccessRule = createAccessRule
export const listOfAdPublishersAnalysisAccessRule = createAccessRule
export const adNetworksAnalysisAccessRule = createAccessRule
export const topAdvertisersAccessRule = createAccessRule
export const topAdPublishersAccessRule = createAccessRule
export const topCreativesAccessRule = createAccessRule
export const topDevelopersAccessRule = createAccessRule
export const appCollectionsAccessRule = createAccessRule
export const creativeCollectionsAccessRule = createAccessRule
